import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes"];
import React, { forwardRef } from 'react';
import { defaultPropObject } from "../constants";
export var TableBody = /*#__PURE__*/forwardRef(function TableBody(_ref, ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("tbody", _extends({}, props, {
    ref: ref,
    className: classes.root
  }));
});